import { ProgressNode } from "../types";

export interface TrackingHierarchy {
  courseId?: number;
  pathId?: number;
}

type TrackingHierarchySource = Pick<
  ProgressNode,
  "parentActivityId" | "grandparentActivityId" | "parentEntityType"
>;

export const toTrackingHierarchy = ({
  parentActivityId,
  grandparentActivityId,
  parentEntityType,
}: TrackingHierarchySource): TrackingHierarchy => {
  if (parentActivityId == null) return {};
  if (parentEntityType === "path") return { pathId: parentActivityId };
  return {
    courseId: parentActivityId,
    ...(grandparentActivityId != null ? { pathId: grandparentActivityId } : {}),
  };
};
